import _ from 'lodash';

import * as api from '../../api';

const upperFirstAll = (string: string) => {
  return string
    .split(' ')
    .map((word) => _.upperFirst(word.toLowerCase()))
    .join(' ');
};

export const getPrettyName = ({ name }: api.Pharmacy.Pharmacy) => {
  return upperFirstAll(name);
};

export const getPrettyAddress = (pharmacy: api.Pharmacy.PrevisitPharmacy) => {
  const trimmedAddress = _.pick(pharmacy.address, [
    'address',
    'unitNumber',
    'city',
    'state',
    'zip',
  ]);

  return _.reduce(
    trimmedAddress,
    (acc, v, k) => {
      if (v) {
        if (k === 'state') {
          acc.push(v);
        } else {
          acc.push(upperFirstAll(v));
        }
      }
      return acc;
    },
    [] as string[],
  ).join(', ');
};
